import { useCallback, useState } from 'react';
import { authApi } from '../../api/auth';
import { GQLArgs } from '../../types';

type ResetPasswordEmailResponse = { resetPassword: { message: string } };

export const useMutationSendMailForResetPassword = (args?: GQLArgs<ResetPasswordEmailResponse>) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ResetPasswordEmailResponse | undefined>();

  const mutation = useCallback(
    async ({ variables }: { variables: { email: string; baseUrl: string } }) => {
      setLoading(true);
      try {
        await authApi.resetPassword(variables.email, variables.baseUrl);
        const shaped: ResetPasswordEmailResponse = { resetPassword: { message: 'ok' } };
        setData(shaped);
        args?.onCompleted?.(shaped);
        return shaped;
      } catch (err: any) {
        args?.onError?.(err);
      } finally {
        setLoading(false);
      }
    },
    [args],
  );

  return { mutation, data, loading, error: undefined };
};
